<template>
  <iz-dialog title="Login" class="modal-languages-password" disableOverlay>
    <div slot="body">
      <field
        ref="languages-password"
        v-model="password"
        label="Password"
        input-type="password"
        label10
        class="flex-1"
        :class="{invalid: isError}"
        @enter="ok()"/>
    </div>
    <div slot="footer">
      <btn icon="back" error @click.native="$emit('cancel')"></btn>
      <btn icon="ok" success @click.native="ok"></btn>
    </div>
  </iz-dialog>
</template>

<script>
import mixinLanguages from '@/mixins/languages'
import Btn from '@/components/basic/Btn'
import IzDialog from '@/components/basic/Dialog'
import Field from '@/components/basic/Field'

export default {
  name: 'EnterLanguagePassword',
  mixins: [mixinLanguages],
  data: () => ({
    password: '',
    isError: false
  }),
  mounted () {
    this.$refs['languages-password'].$el.focus()
  },
  methods: {
    async ok () {
      const isOK = await this.languagesVerifyPassword(this.password)
      if (isOK) {
        this.$emit('ok')
      } else {
        console.log('Error logging in')
        this.$nextTick(() => {
          this.isError = true
        })
        setTimeout(() => {
          this.isError = false
        }, 500)
        this.$refs['languages-password'].$el.focus()
      }
    }
  },
  components: {
    IzDialog,
    Field,
    Btn
  }
}
</script>

<style lang="scss" scoped>
.modal-languages-password {
  width: $size-grid * 6;
  background-color: $white;
}
.invalid {
  background-color: $color-error;
}
</style>



// WEBPACK FOOTER //
// src/modules/languages/dialogs/EnterLanguagePassword.vue